import { architeckCall } from 'database';
import React from "react";
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Row } from "reactstrap";
import { toggleAlert } from 'store/functions/system';
import keys from 'keys';

const required_form_fields = [
    'minutes',
    'problems',
    'description',
]

class DeveloperLogCreate extends React.Component {

    state = {
        project_logs_developers: {
            user: this.props.viewing_user._id,
            project: this.props.project._id,
        },
        canSave: true
    }

    onSave = async () => {

        this.setState({canSave: false})
        //copy state
        let newState = Object.assign({}, this.state.project_logs_developers);
        //assume we have no errors
        let errors = 0;

        required_form_fields.forEach((field) => {
            //check each required field
            if(newState[field]) {
                newState[field + "State"] = 'valid'; 
            } else {
                newState[field + "State"] = 'invalid'; 
                errors++
            }

        })

        this.setState({ project_logs_developers: newState });

        if(!errors) { 

            const u = this.props.viewing_user;
            const p = this.props.project;

            const cost = parseInt(u.hourly_rate) * (parseInt(newState.minutes) / 60)

            const created = await architeckCall({
                method: 'post',
                url: '/api/v1/crud/project_logs_developers/create',
                data: {
                    ...newState,
                    cost 
                },
            });

            if(created.success) {

                 //reset project_logs_developers
                this.setState({project_logs_developers: {
                    user: u._id,
                    project: p._id,
                }}) 

                this.props.onAddDeveloperLog({
                    ...created.data,
                    project: p,
                    user: u
                })

                const link = `${keys.CLIENT_URL}/admin/projects/view/${p._id}?nav=3`

                architeckCall({
                    method: 'POST',
                    url: '/api/v1/integrations/sengrid/branded',
                    data: {
                        "to": 'john@architeck.io',
                        "from": "noreply@architeck.io",
                        "subject": `${u.given_name} ${u.family_name} Has Submitted Hours`,
                        "title":`${u.given_name} ${u.family_name} has updated their hours for project ${this.props.project.name}`,
                        "body": `<a href='${link}'>Click here to view these hours click here or go to: ${link}</a> `
                    }
                }) 

                toggleAlert(true, 'success', 'Hours Submitted!', '2000' )


            } else {

                toggleAlert(true, 'danger', 'An error occurred.', '4000' )
                console.log(created);

            }


        }

        //after load make sure button work again
        this.setState({canSave: true})

    }

    onInputChange = (e, stateName) => {

        let newState = Object.assign({}, this.state.project_logs_developers);
        newState[stateName] = e.target.value;

        if (stateName === "checkbox") {
          if (e.target.value) {
            newState.checkboxState = "valid";
          } else {
            newState.checkboxState = "invalid";
          }
        } else {
          if (e.target.value === "") {
            newState[stateName + "State"] = "invalid";
          } else {
            newState[stateName + "State"] = "valid";
          }
        }

        this.setState({ project_logs_developers: newState });
    };

    render() {

        return (
            <Card>

                {this.state.alert}

                <CardHeader>
                    <Row className="align-items-center">
                        <Col xs="12">
                            <h3 className="mb-0">Log Time</h3>
                            <p>Developers, at the end of every day you work come here to log your time for this project, what got done, and any issues you encountered. You must do this at the end of every day.</p>
                        </Col>
                    </Row>
                </CardHeader>

                <CardBody>

                    <FormGroup>
                        <label className="form-control-label" htmlFor="minutes" > 
                            Minutes Worked
                        </label>
                        <Input
                            id="minutes"
                            value={this.state.project_logs_developers.minutes || ''}
                            placeholder="60"
                            type="number"
                            valid={ this.state.project_logs_developers.minutesState === "valid" }
                            invalid={ this.state.project_logs_developers.minutesState === "invalid" }
                            onChange={e => this.onInputChange(e, "minutes") }
                        />
                        <div className="valid-feedback">Looks good!</div>
                    </FormGroup>

                    <FormGroup>
                        <label className="form-control-label" htmlFor="description" > 
                            What Got Done:
                        </label>
                        <Input
                            style={{minHeight: 200}}
                            id="description"
                            value={this.state.project_logs_developers.description || ''}
                            placeholder="Added in API routes for... Created pages... fixed bug..."
                            type="textarea"
                            valid={ this.state.project_logs_developers.descriptionState === "valid" }
                            invalid={ this.state.project_logs_developers.descriptionState === "invalid" }
                            onChange={e => this.onInputChange(e, "description") }
                        />
                        <div className="valid-feedback">Looks good!</div>
                    </FormGroup>

                    <FormGroup>
                        <label className="form-control-label" htmlFor="problems" > 
                            Any Problems Encountered
                        </label>
                        <Input
                            style={{minHeight: 200}}
                            id="problems"
                            value={this.state.project_logs_developers.problems || ''}
                            placeholder="It looks like the endpoint /api/v1/users/list isn't working..."
                            type="textarea"
                            valid={ this.state.project_logs_developers.problemsState === "valid" }
                            invalid={ this.state.project_logs_developers.problemsState === "invalid" }
                            onChange={e => this.onInputChange(e, "problems") }
                        />
                        <div className="valid-feedback">Looks good!</div>
                    </FormGroup>

                    <div className="mt-3 text-right">
                        <Button onClick={this.onSave} className="btn btn-success">Submit</Button>
                    </div>
            
                </CardBody>
            </Card>
        );
    }
}



const mapStateToProps = state => {
    return {
  
      viewing_user: state.auth.viewing_user,
  
    };
};
  
export default connect(mapStateToProps, '')(DeveloperLogCreate);